import {
  email,
  string,
} from 'zod';

export const emailAddressSchema = string()
  .min(1, { error: 'Enter the email address.' })
  .pipe(email({ error: 'Enter a valid email address.' }));

export const microsoftEmailAddressSchema = emailAddressSchema.pipe(
  string().refine(
    (emailAddress) => emailAddress.toLowerCase().endsWith('@microsoft.com'),
    'Enter a Microsoft email address that ends in @microsoft.com.',
  ),
);
